import React, { useContext, useState } from 'react';
import axios from 'axios';
import { Box } from '@mui/material';
import ChargesBox from '../../components/sections/paymentsTab/ChargesBox';
import CaseHistoryBox from '../../components/sections/paymentsTab/CaseHistoryBox';
import { apiRoute } from '../../App.js';
import UserContext from '../../../src/context/UserContext.js';

const PaymentsView = (props) => {
    const { updateCaseBalance, ts, state, statuteRows, violationRows, setViolationRows, modalType, setModalType, modalWidth, setModalWidth, modal, setModal, openBatches, setPaymentBatchNumber, checked, setChecked, left, setLeft, right, setRight, creditCardViolationCheckedItems, setCreditCardViolationCheckedItems } = props;
    const [violationBalance, setViolationBalance] = useState(0);
    const [violation, setViolation] = useState({});
    const [selectedPayment, setSelectedPayment] = useState({});
    const { userName } = useContext(UserContext);

    // STATE THAT HOLDS THE RECEIPT NUMBER OF THE NEWLY MADE PAYMENT
    const [receiptNumber, setReceiptNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [retrieveReceiptPayment, setRetrieveReceiptPayment] = useState([]);
    const [chargeBack, setChargeBack] = useState(false);
    const [chargeBackSettleDate, setChargeBackSettleDate] = useState(false);
    const [chargeBackSettlement, setChargeBackSettlement] = useState(false);

    const handleOpen = async (type, width) => {
        if (((openBatches != null || openBatches !== undefined) && openBatches.length > 0) || type === 'retrieveReceipt') {
            setModalType(type);
            setModalWidth(width);
            setModal(true);
        } else {
            try {
                setModalType('openBatch');
                setModalWidth('25%');
                setModal(true);
            } catch (err) {
                console.log('error getting newBatch', err);
            }
        }
    };

    const handleClose = () => {
        setModal(false);
        setModalType('');
        setPaymentBatchNumber(null);
        if (modalType === 'creditCard') {
            setViolation({})
        }
        //setLeft(chargeBackSettlement ? [] : violationRows.filter(v => v.remainingBalance >= 0.01 && v.amendedDate == null).map(v => v));
        setRight([]);
        setChecked([]);
        setChargeBackSettlement(false);
    };


    const retrieveReceipt = async (params) => {
        await axios.get(`${apiRoute}/api/ffpaymenttbls/${params.row.pkFfPaymentId}`)
            .then(res => {
                setRetrieveReceiptPayment(res.data)
            })
            .catch(err => console.log('err fetching receipt from the front end: ', err));
        handleOpen('retrieveReceipt', '30%');
    };

    return (
        <Box sx={{ width: '99%', m: '0 auto' }}>
            <ChargesBox
                modal={modal}
                handleClose={handleClose}
                handleOpen={handleOpen}
                violationBalance={violationBalance}
                setViolationBalance={setViolationBalance}
                openBatches={openBatches}
                updateCaseBalance={updateCaseBalance}
                violation={violation}
                setViolation={setViolation}
                modalType={modalType}
                modalWidth={modalWidth}
                ts={ts}
                loading={loading}
                setLoading={setLoading}
                selectedPayment={selectedPayment}
                receiptNumber={receiptNumber}
                setReceiptNumber={setReceiptNumber}
                state={state}
                userName={userName}
                retrieveReceipt={retrieveReceipt}
                setRetrieveReceiptPayment={setRetrieveReceiptPayment}
                retrieveReceiptPayment={retrieveReceiptPayment}
                statuteRows={statuteRows}
                violationRows={violationRows}
                setViolationRows={setViolationRows}
                checked={checked}
                setChecked={setChecked}
                left={left}
                setLeft={setLeft}
                right={right}
                setRight={setRight}
                creditCardViolationCheckedItems={creditCardViolationCheckedItems}
                setCreditCardViolationCheckedItems={setCreditCardViolationCheckedItems}
                chargeBack={chargeBack}
                setChargeBack={setChargeBack}
                chargeBackSettleDate={chargeBackSettleDate}
                setChargeBackSettleDate={setChargeBackSettleDate}
                chargeBackSettlement={chargeBackSettlement}
                setChargeBackSettlement={setChargeBackSettlement}
            />
            <CaseHistoryBox
                handleOpen={handleOpen}
                setSelectedPayment={setSelectedPayment}
                selectedPayment={selectedPayment}
                retrieveReceipt={retrieveReceipt}
                setRetrieveReceiptPayment={setRetrieveReceiptPayment}
                retrieveReceiptPayment={retrieveReceiptPayment}
            />
        </Box>
    )
}

export default PaymentsView;
